export { MedRecValidator } from './MedRecValidator';
